import PSprite from './PSprite';
import PGlobal from './PGlobal';
import AudioPeaks from './component/AudioPeaks';
import AudioConst from './AudioConst';

const _peaks = [];
export default class AudioTrk extends PSprite {
    constructor() {
        super();
        this._interval = 0;
        this.fixedH = 0;
        this._selected = false;
        this._stretchMode = false;
        this._data = null;
        this._range = null;
        this.canvas = new PIXI.Graphics();
        this.leftHaul = null;
        this.rightHaul = null;
        this.addChild(this.canvas);
    }

    set interval(value) {
        this._interval = value;
        this.dirty();
    }

    set range(range){
        this._range = range;
    }

    redraw() {
        this.canvas.clear();
        if(this._data) {
            this.fixedW = (this._data.end-this._data.start) * this._interval;
            if(this.x > this._range.max || this.x + this.fixedW < this._range.min){
                //不在显示范围内
                return;
            }
            //填充
            this.canvas.beginFill(0x4a9f95);
            this.canvas.drawRect(0, 0, this.fixedW, this.fixedH);
            this.canvas.endFill();
            //
            let peakColor = 0x47d4c4;
            let borderColor = 0x458880;
            if(this._selected) {
                peakColor = 0xFFFFFF;
                borderColor = 0xFFFFFF;
            }
            //音波
            this.drawPeaks(peakColor);
            //边框
            this.canvas.beginFill(borderColor);
            this.canvas.drawRect(0, 0, this.fixedW, 1);
            this.canvas.drawRect(0, this.fixedH - 1, this.fixedW, 1);
            this.canvas.drawRect(0, 0, 1, this.fixedH);
            this.canvas.drawRect(this.fixedW - 1, 0, 1, this.fixedH);
            this.canvas.endFill();
            //
            this._showHaul(this._stretchMode);
        }
    }

    onRemoved(){
        this._data = null;
        // 清理监听器，避免内存泄漏
        if(this._peaksListeners){
            for(let audioId in this._peaksListeners){
                const peaks = _peaks[audioId];
                if(peaks){
                    peaks.off("load", this._peaksListeners[audioId]);
                }
            }
            this._peaksListeners = null;
        }
    }

    set stretchMode(value) {
        if(this._stretchMode != value) {
            this._stretchMode = value;
            this.dirty();
        }
    }

    get stretchMode() {
        return this._stretchMode;
    }

    set selected(b) {
        this._selected = b;
        this.dirty();
    }

    get selected() {
        return this._selected;
    }

    set data(data) {
        this._data = data;
        this.dirty();
    }

    get data() {
        return this._data;
    }

    setHeight(value) {
        this.fixedH = value;
    }

    getWidth() {
        return this.fixedW;
    }

    _showHaul(flag){
        if(!this.leftHaul){
            const texture = PGlobal.resources.mainUI.textures['track_icon_haul'];
            this.leftHaul = new PIXI.Sprite(texture);
            this.rightHaul = new PIXI.Sprite(texture);
            const y = (this.fixedH - this.leftHaul.height) / 2 - 0.5;
            this.leftHaul.y = y;
            this.rightHaul.y = y;
            this.leftHaul.scale = {x:-1, y: 1};
        }
        window.trk = this;
        if(flag){
            this.addChild(this.leftHaul);
            this.addChild(this.rightHaul);
            const x = this.leftHaul.width / 2 - 0.5;
            this.rightHaul.x = this.getWidth() - x;
            this.leftHaul.x = x;
        } else if(this.leftHaul.parent){
            this.removeChild(this.leftHaul);
            this.removeChild(this.rightHaul);
        }
    }

    drawPeaks(fillColor){
        const data = this.data;
        if(!data){return;}
        const audioId = data.audioId;
        const peaks = this._getPeaks(audioId);
        if(!peaks){
            return;
        }

        const start = data.audioStart;
        const end = data.end - data.start + start;
        const hArray = peaks.getRangePeaks(start, end);
        const y = AudioConst.AUDIO_STEP_H;
        const hMax = AudioConst.AUDIO_STEP_H - 5;
        const graphic = this.canvas;
        //const fillColor = 0x47d4c4;
        graphic.beginFill(fillColor);
        const points = [];
        let j = 0;
        let len = hArray.length * 2 + 4;
        points[len - 1] = y;
        points[len - 2] = hArray.length - 1;

        points[j ++] = 0;
        points[j ++] = y;

        hArray.forEach((h, i)=>{
            points[j ++] = i;
            points[j ++] = y - h * hMax;
        });

        graphic.drawPolygon(points);
        graphic.endFill();
    }
    /**
     * 
     * @param {*} audioId 
     * @returns {AudioPeaks}
     */
    _getPeaks(audioId){
        let peaks = _peaks[audioId];
        if(!peaks){
            peaks = new AudioPeaks(audioId);
            _peaks[audioId] = peaks;
        }
        
        // 如果还没加载完成，注册监听器（每个AudioTrk实例都需要注册）
        if(!peaks.loaded){
            // 检查是否已经为这个实例注册过监听器
            if(!this._peaksListeners){
                this._peaksListeners = {};
            }
            if(!this._peaksListeners[audioId]){
                const listener = () => {
                    this.dirty();
                };
                peaks.on("load", listener);
                this._peaksListeners[audioId] = listener;
            }
            return null;
        }
        return peaks;
    }

}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioTrk.js